module.exports = __webpack_public_path__ + "img/6ne.343725f9.svg";